export const USER= {
	BOGDAN: '854716e0-d72a-45f7-9610-9d6a20ff17e6',
	MUHA: 'f1cb53ee-970f-4926-a1af-ed3e87befa1e',
}
